// extracted by mini-css-extract-plugin
module.exports = {"policyContainer":"rate_plan_policies_policyContainer__1jIi_","policyCell":"rate_plan_policies_policyCell__vxG0r","mealContainer":"rate_plan_policies_mealContainer__3_FkM"};